interface PrivateFeedIconProps {
  size?: number;
  color?: string;
  className?: string;
}

// "P in a circle" badge marking private feeds, mirroring LockIcon's API. Replaces the
// former padlock glyph, which clashed visually with the keep-unread lock in the reader.
const PrivateFeedIcon: React.FC<PrivateFeedIconProps> = ({ size = 16, color = 'currentColor', className }) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: 'inline-block', verticalAlign: 'middle', color }}
      aria-hidden="true"
    >
      <circle cx="8" cy="8" r="7" stroke="currentColor" strokeWidth="1.5" fill="none" />
      <text
        x="8"
        y="8"
        textAnchor="middle"
        dominantBaseline="central"
        fontSize="9.5"
        fontWeight="700"
        fontFamily="system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif"
        fill="currentColor"
      >
        P
      </text>
    </svg>
  );
};

export default PrivateFeedIcon;
